import apiServices from 'config/apiServiceApiGateway'
import { WhitelistSegmentUserType } from '../@types/WhitelistSegment'

const { Get, Post, Put, Delete } = apiServices

export type WhitelistSegmentSegmentType = {
  segment_id: number
  segment_name: string
}

export type WhitelistSegmentItemType = {
  segments: WhitelistSegmentSegmentType[]
  customer_id: number
  user_type: WhitelistSegmentUserType
  phone: string
  created_at: string
  updated_at: string
}

export type PaginationType = {
  page_size: number
  previous_page_exist: boolean
  page_item: number
  previous_cursor: string
  next_cursor: string
  next_page_exist: boolean
  page_cursor: string
  cursor_direction: string
}
export type GetWhitelistSegmentListResponseType = {
  data: WhitelistSegmentItemType[]
  pagination: PaginationType
  error: {
    message: string
    code: number
    status: boolean
  }
}

export type GetWhitelistSegmentListRequestType = {
  params?: { limit: number; cursor?: string; direction?: 'next' | 'prev'; segment_name?: string }
}

export const getWhitelistSegmentList = ({ params }: GetWhitelistSegmentListRequestType = {}) =>
  Get<GetWhitelistSegmentListResponseType, true>({
    params,
    url: '/segmentation/internal/v1/whitelist-segment',
  })

export type PostCreateWhitelistSegmentRequestType = {
  customer_id: number
  segments: WhitelistSegmentSegmentType[]
  user_type: WhitelistSegmentUserType
  phone: string
}

export type PostCreateWhitelistSegmentResponseType = {
  data: {
    message: string
  }
  error: {
    message: string
    code: number
    status: boolean
  }
}

export const postCreateWhitelistSegment = (data: PostCreateWhitelistSegmentRequestType) =>
  Post<PostCreateWhitelistSegmentResponseType, true>({
    url: '/segmentation/internal/v1/whitelist-segment',
    data,
  })

export type PutUpdateWhitelistSegmentRequestType = {
  customerId: number
  segments: WhitelistSegmentSegmentType[]
  user_type: WhitelistSegmentUserType
  phone: string
}

export type PutUpdateWhitelistSegmentResponseType = {
  data: {
    message: string
  }
  error: {
    message: string
    code: number
    status: boolean
  }
}

export const putUpdateWhitelistSegment = ({
  customerId,
  segments,
  user_type,
  phone,
}: PutUpdateWhitelistSegmentRequestType) =>
  Put<PutUpdateWhitelistSegmentResponseType, true>({
    url: `/segmentation/internal/v1/whitelist-segment/${customerId}`,
    data: { customer_id: customerId, segments, user_type, phone },
  })

export type DeleteWhitelistSegmentRequestType = {
  customerId: number
}

export type DeleteWhitelistSegmentResponseType = {
  data: {
    message: string
  }
  error: {
    message: string
    code: number
    status: boolean
  }
}

export const deleteWhitelistSegment = ({ customerId }: DeleteWhitelistSegmentRequestType) =>
  Delete<DeleteWhitelistSegmentResponseType, true>({
    url: `/segmentation/internal/v1/whitelist-segment/${customerId}`,
  })

export type WhitelistOtpDummyItemType = {
  id: number
  customer_id: number
  phone_number: string
  name: string
  domain: string
  otp_number: string
  is_dummy: boolean
  is_new_buyer: boolean
  created_by: string
  updated_by: string
  created_at: string
  updated_at: string
}

export type WhitelistOtpDummyPaginationType = {
  page_item: number
  page_size: number
  page_cursor: string
  previous_cursor: string
  next_cursor: string
  cursor_direction: string
  next_page_exist: boolean
  previous_page_exist: boolean
}

export type GetWhitelistOtpDummyListResponseType = {
  data: {
    customer_whitelist_otps: Nullable<WhitelistOtpDummyItemType[]>
  }
  pagination: WhitelistOtpDummyPaginationType
  error: {
    message: string
    code: number
    status: boolean
  }
}

export type GetWhitelistOtpDummyListParamsType = {
  cursor?: string
  direction?: 'asc' | 'desc'
  domain?: string
  page_size?: number
  /** Prefix match against the normalized phone number, e.g. "0878" or "+62878" */
  phone_number?: string
  sort?: string
}

export const getWhitelistOtpDummyList = (params: GetWhitelistOtpDummyListParamsType = {}) =>
  Get<GetWhitelistOtpDummyListResponseType, true>({
    url: '/accounts/internal/v1/otp/whitelist-otp-dummy',
    params: {
      cursor: '',
      direction: 'asc',
      domain: '',
      page_size: 20,
      phone_number: '',
      sort: 'id',
      ...params,
    },
  })
